import { type JSX, useId } from 'react'
import { cn } from '#src/cn.ts'

export function IconHexagonDotted({
  className,
}: {
  className?: string
}): JSX.Element {
  const id = useId()
  return (
    <svg
      className={cn('size-4 shrink-0', className)}
      width="16"
      height="16"
      viewBox="-1 -1 16 16"
      fill="none"
      stroke="none"
    >
      <path
        d="M2.95778 3.02069L5.70777 1.36023C6.50244 0.88041 7.49756 0.88041 8.29223 1.36024L11.0422 3.02074C11.7918 3.47336 12.25 4.2852 12.25 5.16086V8.84803C12.25 9.7251 11.7904 10.5381 11.0388 10.9902L8.29114 12.6433C7.49693 13.1211 6.50355 13.1203 5.71011 12.6412L2.95775 10.9792C2.20815 10.5266 1.75 9.7148 1.75 8.83911V5.16082C1.75 4.28516 2.20816 3.47332 2.95778 3.02069Z"
        stroke="lch(68.75% 1.608 272.005)"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
        strokeDasharray="1.65 1.35"
        strokeDashoffset="2.3"
        fill="none"
      ></path>
      <g mask={`url(#${id}-hole-0)`}>
        <circle
          r="4"
          cx="7"
          cy="7"
          stroke="lch(68.75% 1.608 272.005)"
          fill="none"
          strokeWidth="8"
          strokeDasharray="calc(0) 25.12"
          transform="rotate(-90) translate(-14, 0)"
        ></circle>
      </g>
      <mask id={`${id}-hole-0`} maskUnits="userSpaceOnUse">
        <path
          transform="translate(-1, -1)"
          d="M8.3779 4.74233C8.14438 4.60607 7.85562 4.60607 7.6221 4.74233L5.37209 6.05513C5.14168 6.18957 5 6.4363 5 6.70311V9.34216C5 9.60897 5.14168 9.85573 5.37209 9.99016L7.6221 11.303C7.85562 11.4392 8.14438 11.4392 8.3779 11.303L10.6279 9.99016C10.8583 9.85573 11 9.60897 11 9.34216V6.70311C11 6.4363 10.8583 6.18957 10.6279 6.05513L8.3779 4.74233Z"
          fill="white"
        ></path>
      </mask>
    </svg>
  )
}
